import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('sessionToken')
      window.location.href = '/signin'
    }
    return Promise.reject(error)
  }
)

export const configAPI = {
  // Get config for current tenant
  getConfig: () => {
    return api.get('/api/config')
  },

  // Create or update config
  createOrUpdateConfig: (configData) => {
    return api.post('/api/config', configData)
  },

  // Update config
  updateConfig: (configData) => {
    return api.put('/api/config', configData)
  },

  // Delete config
  deleteConfig: () => {
    return api.delete('/api/config')
  }
}

export default configAPI

















